export const ALL_CAMPAIGN_TYPES = {
  GOOGLE_SEARCH_TRAFFIC: {
    label: 'Search Tráfico',
    platform: 'google',
    key: 'GOOGLE_SEARCH_TRAFFIC',
    campaign_type: 'SEARCH',
    requires_conversions: false,
    requires_merchant_center: false,
    title: 'Aparecé en las búsquedas',
    chatbotMessage: 'Crea 5 headlines de máximo 28 caracteres y 3 descriptions de máximo 80 caracteres, relacionadas a mi negocio. El array de headlines y el de descriptions deben estar en ad_content. También crea keywords en google_settings.keywords.',
    description: 'Aparecé en Google y recibí visitas de personas que te están buscando.',  
  },
  GOOGLE_PMAX_NO_CATALOG: {
    label: 'Performance Max',
    platform: 'google',
    key: 'GOOGLE_PMAX_NO_CATALOG',
    campaign_type: 'PERFORMANCE_MAX',
    requires_conversions: true,
    requires_merchant_center: false,
    title: 'Expandí tu alcance',
    chatbotMessage: 'Crea 5 headlines de máximo 28 caracteres y 3 descriptions de máximo 80 caracteres, relacionadas a mi negocio. El array de headlines y el de descriptions deben estar en ad_content. Aunque el usuario tenga merchant center, no lo uses para esta campaña. Repito, google_settings.merchant_center_id TIENE QUE SER NULL para esta campaña.',
    description: 'Aparecé en Google, Youtube, Gmail y maps.',
  },
  GOOGLE_PMAX_WITH_CATALOG: {
    label: 'Performance Max Catálogo',
    platform: 'google',
    key: 'GOOGLE_PMAX_WITH_CATALOG',
    campaign_type: 'PERFORMANCE_MAX',
    requires_conversions: true,
    requires_merchant_center: true,
    title: 'Vendé tus productos en Google',
    chatbotMessage: 'Crea 5 headlines de máximo 28 caracteres y 3 descriptions de máximo 80 caracteres, relacionadas a mi negocio. El array de headlines y el de descriptions deben estar en ad_content.',
    description: 'Ideal para e-commerce que quieren escalar ventas.',
  },
  META_TRAFFIC: {
    label: 'Meta Tráfico',
    platform: 'meta',
    key: 'META_TRAFFIC',
    campaign_type: 'OUTCOME_TRAFFIC',
    requires_catalog: false,
    requires_pixel: false,
    title: 'Atráe tráfico en Redes',
    chatbotMessage: 'Es muy importante que NO uses un catálogo ni un pixel para esta campaña. Quiero 1 headline y 1 descripción larga.',
    description: 'Aparecé en Facebook e Instagram y atraé gente interesada en tu negocio.', 
  },
  META_CONVERSIONS: {
    label: 'Meta Conversiones',
    platform: 'meta',
    key: 'META_CONVERSIONS',
    campaign_type: 'OUTCOME_SALES',
    requires_catalog: false,
    requires_pixel: true,
    title: 'Vendé en Facebook e Instagram',
    chatbotMessage: 'Es muy importante que NO uses un catálogo para esta campaña. Si usa un píxel, pero no un catálogo. Quiero 1 headline y 1 descripción larga.',
    description: 'Campañas optimizadas para generar ventas y registros en tu web.',
  },
  META_CATALOG: {
    label: 'Catálogo',
    platform: 'meta',
    key: 'META_CATALOG',
    campaign_type: 'OUTCOME_SALES',
    requires_catalog: true,
    requires_pixel: true,
    title: 'Tu catálogo en Facebook e Instagram',
    chatbotMessage: 'Asegúrate de usar un catálogo para esta campaña. Quiero 1 headline y 1 descripción larga.',
    description: 'Perfecto para Tiendas online.',
  },
  WHATSAPP_CONVERSATIONS: {
    label: 'WhatsApp Conversaciones',
    platform: 'meta',
    special_platform: 'whatsapp',
    key: 'WHATSAPP_CONVERSATIONS',
    campaign_type: 'WHATSAPP_BUSINESS',
    title: 'Clientes directo a WhatsApp',
    chatbotMessage: 'Es muy importante que NO uses un catálogo ni un pixel para esta campaña de WhatsApp. Quiero 1 headline y 1 descripción larga para dirigir tráfico a WhatsApp. cuando crees la campaña, no ye olvides de asociar el número de WhatsApp a la campaña en meta_settings.whatsapp_settings.whatsapp_phone_number',
    requires_whatsapp_business: true,
    description: 'Tus anuncios llevan a los usuarios a chatear con vos en WhatsApp.',
  },
}